import styled from 'styled-components';
import LoadingImage from '../../Global/LoadingImage/LoadingImage';

export const FeaturedItemContainer = styled.section`
	& + section {
		header {
			border-top: unset;
			padding-top: 3rem;
		}
	}
	.swiper {
		background-color: var(--ion-color-primary);
	}
`;

export const FeaturedItemInner = styled.div`
	position: relative;
	height: 50svh;
	max-height: 500px;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
`;

export const FeaturedItemImg = styled(LoadingImage)`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	z-index: 0;
`;

export const FeaturedItemTextContainer = styled.div`
	position: absolute;
	width: 100%;
	color: #fff;
	padding: 1rem 1rem 1.5rem;
	bottom: 0.5rem;
`;

export const FeaturedItemTitle = styled.h2`
	font-size: 1.8rem;
	line-height: 1;
	margin: 0 0 0.3rem;
`;

export const FeaturedItemMeta = styled.p`
	margin: 0;
	font-size: 0.75rem;
	//text-transform: uppercase;
	color: var(--ion-color-light-shade);
`;
